import toggleClass from 'utils/DOM/toggleClass'

function individualState(state) {
  if (['ID', 'MO', 'NC', 'ND', 'OR'].indexOf(state) >= 0) {
    toggleClass(document.body, 'individual-state')
  }
}

export default individualState
